import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ConstantService } from '@app/_services/constant.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ResRevDetailComponent } from '@app/_components/report/components/res-rev-detail/res-rev-detail.component';


@Component({
    selector: 'app-res-rev-total',
    templateUrl: './res-rev-total.component.html',
    styleUrls: ['./res-rev-total.component.css'],
    providers: [DialogService],
    standalone: false
})
export class ResRevTotalComponent implements OnInit {
	@Input() resRevenues: any = [];
	columns: any[];
	constructor(
		public constantService: ConstantService,
		public dialogService: DialogService) { }


	ngOnInit(): void {

		this.columns = [
			{ field: 'year', header: 'Year', type: 'num' },
			{ field: 'monthName', header: 'Month', type: 'str' },
			{ field: 'day', header: 'Day', type: 'num' },
			{ field: 'numNtsOccTTL', header: 'Occ Nts', type: 'num' },
			{ field: 'numNtsUnAvailToRentTTL', header: 'Unavail Nts', type: 'num' },
			{ field: 'numNtsRentedTTL', header: 'Rented Nts', type: 'num' },
			{ field: 'numResTTL', header: 'Bookings', type: 'num' },
			{ field: 'revRoomRateNetTTL', header: 'Room Rev', type: 'cur' },
			{ field: 'revOwnerNetTTL', header: 'Owner Ttl $', type: 'cur' },
			{ field: 'revHousekeepingTTL', header: 'Housekeeping', type: 'cur' },
			{ field: 'revResortTTL', header: 'Resort', type: 'cur' },
			{ field: 'revDamageWaiverTTL', header: 'Damage', type: 'cur' },
			{ field: 'revCommissionTTL', header: 'Commission', type: 'cur' },
			{ field: 'revMgrTTL', header: 'Mgr Ttl $', type: 'cur' },
		];

	}





	ngOnChanges(changes: SimpleChanges): void {
		if (this.resRevenues) {
			this.resRevenues = this.resRevenues;
		}
	}


	showResRevDetail(rowData: any) {
		const ref = this.dialogService.open(ResRevDetailComponent, {
			data: {
				resRevenue: rowData
			},
			header: 'Reservation Detail',
			width: '90%'
		});
	}


	getResStatusColor(resStatus) {
		return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus })?.color;
	}

	getResStatusName(resStatus) {
		return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus })?.label;
	}

	getLocationColor(locationId) {
		return this.constantService.locations.find(function(item) { return item.locationId === locationId })?.color;
	}

	getLocationName(locationId) {
		return this.constantService.locations.find(function(item) { return item.locationId === locationId })?.name;
	}

	getRefSrcImage(refSrcId) {
		return this.constantService.refSrcImages.find(function(item) { return item.value === refSrcId })?.imgurl;
	}


	columnsAll = [
		{ field: 'locationId', header: 'locationId' },
		{ field: 'shortTermRentalId', header: 'shortTermRentalId' },
		{ field: 'reservationId', header: 'reservationId' },
		{ field: 'orderId', header: 'orderId' },
		{ field: 'soldByUserId', header: 'soldByUserId' },
		{ field: 'soldByAssistUserId', header: 'soldByAssistUserId' },
		{ field: 'saleDate', header: 'saleDate' },
		{ field: 'saleYear', header: 'saleYear' },
		{ field: 'saleMonth', header: 'saleMonth' },
		{ field: 'saleDay', header: 'saleDay' },
		{ field: 'saleDayOfWeek', header: 'saleDayOfWeek' },
		{ field: 'saleTime24', header: 'saleTime24' },
		{ field: 'saleTime12', header: 'saleTime12' },
		{ field: 'developmentName', header: 'developmentName' },
		{ field: 'propertyCode', header: 'propertyCode' },
		{ field: 'propertyType', header: 'propertyType' },
		{ field: 'numBedrooms', header: 'numBedrooms' },
		{ field: 'floorOfProperty', header: 'floorOfProperty' },
		{ field: 'view', header: 'view' },
		{ field: 'hotelType', header: 'hotelType' },
		{ field: 'guestLastName', header: 'guestLastName' },
		{ field: 'guestCity', header: 'guestCity' },
		{ field: 'guestState', header: 'guestState' },
		{ field: 'guestPostalCode', header: 'guestPostalCode' },
		{ field: 'resStatus', header: 'resStatus' },
		{ field: 'resStatusName', header: 'resStatusName' },
		{ field: 'checkInDate', header: 'checkInDate' },
		{ field: 'checkOutDate', header: 'checkOutDate' },
		{ field: 'commissionRate', header: 'commissionRate' },
		{ field: 'soldBy', header: 'soldBy' },
		{ field: 'soldByAssist', header: 'soldByAssist' },
		{ field: 'prebookDaysTTL', header: 'prebookDaysTTL' },
		{ field: 'prebookMonthsTTL', header: 'prebookMonthsTTL' },
		{ field: 'numOccupantsTTL', header: 'numOccupantsTTL' },
		{ field: 'numAdultsTTL', header: 'numAdultsTTL' },
		{ field: 'numChildrenTTL', header: 'numChildrenTTL' },
		{ field: 'numNightsTTL', header: 'numNightsTTL' },
		{ field: 'numNightsGuestTTL', header: 'numNightsGuestTTL' },
		{ field: 'numNightsOwnerTTL', header: 'numNightsOwnerTTL' },
		{ field: 'numNightsOwnerGuestTTL', header: 'numNightsOwnerGuestTTL' },
		{ field: 'numNightsNotAvailTTL', header: 'numNightsNotAvailTTL' },
		{ field: 'numNightsHoldTTL', header: 'numNightsHoldTTL' },
		{ field: 'numNightsHoldExpireTTL', header: 'numNightsHoldExpireTTL' },
		{ field: 'numNightsGuestCancelTTL', header: 'numNightsGuestCancelTTL' },
		{ field: 'numNightsOwnerCancelTTL', header: 'numNightsOwnerCancelTTL' },
		{ field: 'numNightsOwnerGuestCancelTTL', header: 'numNightsOwnerGuestCancelTTL' },
		{ field: 'numNightsPostponeTTL', header: 'numNightsPostponeTTL' },
		{ field: 'revAdjustmentTTL', header: 'revAdjustmentTTL' },
		{ field: 'revFreeCarTTL', header: 'revFreeCarTTL' },
		{ field: 'revFreeRentTTL', header: 'revFreeRentTTL' },
		{ field: 'revRoomRateGrossTTL', header: 'revRoomRateGrossTTL' },
		{ field: 'revRoomRateNetTTL', header: 'revRoomRateNetTTL' },
		{ field: 'revHousekeepingTTL', header: 'revHousekeepingTTL' },
		{ field: 'revLateCheckOutTTL', header: 'revLateCheckOutTTL' },
		{ field: 'revOccupancyTTL', header: 'revOccupancyTTL' },
		{ field: 'revResortTTL', header: 'revResortTTL' },
		{ field: 'revTravelInsTTL', header: 'revTravelInsTTL' },
		{ field: 'revTravelInsPremTTL', header: 'revTravelInsPremTTL' },
		{ field: 'revDamageWaiverTTL', header: 'revDamageWaiverTTL' },
		{ field: 'revDamageWaiverPremTTL', header: 'revDamageWaiverPremTTL' },
		{ field: 'revCreditCardTTL', header: 'revCreditCardTTL' },
		{ field: 'revCancelTTL', header: 'revCancelTTL' },
		{ field: 'revRollawayTTL', header: 'revRollawayTTL' },
		{ field: 'revPetTTL', header: 'revPetTTL' },
		{ field: 'revCommissionTTL', header: 'revCommissionTTL' },
		{ field: 'revMgrTTL', header: 'revMgrTTL' },
		{ field: 'numNightsAVG', header: 'numNightsAVG' },
		{ field: 'numNightsGuestAVG', header: 'numNightsGuestAVG' },
		{ field: 'numNightsOwnerAVG', header: 'numNightsOwnerAVG' },
		{ field: 'numNightsOwnerGuestAVG', header: 'numNightsOwnerGuestAVG' },
		{ field: 'numNightsNotAvailAVG', header: 'numNightsNotAvailAVG' },
		{ field: 'numNightsHoldAVG', header: 'numNightsHoldAVG' },
		{ field: 'numNightsHoldExpireAVG', header: 'numNightsHoldExpireAVG' },
		{ field: 'numNightsGuestCancelAVG', header: 'numNightsGuestCancelAVG' },
		{ field: 'numNightsOwnerCancelAVG', header: 'numNightsOwnerCancelAVG' },
		{ field: 'numNightsOwnerGuestCancelAVG', header: 'numNightsOwnerGuestCancelAVG' },
		{ field: 'numNightsPostponeAVG', header: 'numNightsPostponeAVG' },
		{ field: 'revAdjustmentAVG', header: 'revAdjustmentAVG' },
		{ field: 'revFreeCarAVG', header: 'revFreeCarAVG' },
		{ field: 'revFreeRentAVG', header: 'revFreeRentAVG' },
		{ field: 'revRoomRateGrossAVG', header: 'revRoomRateGrossAVG' },
		{ field: 'revRoomRateNetAVG', header: 'revRoomRateNetAVG' },
		{ field: 'revHousekeepingAVG', header: 'revHousekeepingAVG' },
		{ field: 'revLateCheckOutAVG', header: 'revLateCheckOutAVG' },
		{ field: 'revOccupancyAVG', header: 'revOccupancyAVG' },
		{ field: 'revResortAVG', header: 'revResortAVG' },
		{ field: 'revTravelInsAVG', header: 'revTravelInsAVG' },
		{ field: 'revTravelInsPremAVG', header: 'revTravelInsPremAVG' },
		{ field: 'revDamageWaiverAVG', header: 'revDamageWaiverAVG' },
		{ field: 'revDamageWaiverPremAVG', header: 'revDamageWaiverPremAVG' },
		{ field: 'revCreditCardAVG', header: 'revCreditCardAVG' },
		{ field: 'revCancelAVG', header: 'revCancelAVG' },
		{ field: 'revRollawayAVG', header: 'revRollawayAVG' },
		{ field: 'revPetAVG', header: 'revPetAVG' },
		{ field: 'revCommissionAVG', header: 'revCommissionAVG' },
		{ field: 'revMgrAVG', header: 'revMgrAVG' }
	];
}
